import { NgModule } from '@angular/core';
import { HotjarComponent } from './hotjar.component';

@NgModule({
  declarations: [HotjarComponent],
  exports: [HotjarComponent]
})
export class HotjarModule {}